import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class DismissableBaseService<T> {
  abstract query(entityId: number, type?: any): Observable<T[]>;
  abstract update(customerId: number, entityId: number, object: any, dismiss: boolean): Observable<any>;
}
